import { HBLockedAccount } from '../components/HBLockedAccount';
import { Identifier, Position } from '../types';
export default function upsells(userInfo) {
    const { isAccountLocked } = userInfo;
    return {
        [Position.DashboardHintBar]: [
            {
                identifier: Identifier.LockedAccount,
                component: HBLockedAccount,
                isClosable: false,
                condition: isAccountLocked,
            },
        ],
    };
}
